import React, { useRef } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import DialogShell from './dialog-shell';
import { TWButton, TWInput, IconBadge } from '../../../../components/ui';

const SendEmailDialog = ({
  open,
  onClose,
  email,
  setEmail,
  loading,
  onConfirm,
}) => {
  const cancelRef = useRef(null);

  return (
    <DialogShell
      open={open}
      onClose={onClose}
      maxWidth="sm:max-w-md"
      initialFocus={cancelRef}
    >
      <div className="px-6 pt-6">
        <div className="flex items-start gap-3">
          <IconBadge icon={EnvelopeIcon} tone="blue" size="md" />
          <div className="flex-1">
            <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
              Send Receipt by Email
            </h2>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Confirm or update the email address for this receipt.
            </p>
          </div>
        </div>
      </div>

      <div className="px-6 py-5">
        <TWInput
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="owner@example.com"
        />
      </div>

      <div className="flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-6 py-4 dark:border-slate-700 dark:bg-slate-900/40">
        <TWButton
          ref={cancelRef}
          label="Cancel"
          disabled={loading}
          onClick={onClose}
        />
        <TWButton
          variant="primary"
          label="Send Email"
          loading={loading}
          disabled={loading}
          onClick={onConfirm}
        />
      </div>
    </DialogShell>
  );
};

export default SendEmailDialog;
